// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.categories-section {
  margin-top: 5%;
  margin-bottom: 5%;
  padding-left: 10%;
}

.categories-images-container {
  background: #98e8fc;
  width: 130px;
  height: 130px;
}

.category-image {
  width: 60px;
  height: 100%;
  object-fit: contain;
}

.categories-header {
  font-size: 50px;
}

.category-items {
  overflow-y: scroll;
  overflow-x: hidden !important;
}

@media only screen and (max-width: 992px) {
  .category-items {
    display: flex;
    flex-wrap: nowrap !important;
    overflow: auto !important;
    width: 100% !important;
  }
}
@media only screen and (max-width: 767px) {
  .categories-header {
    font-size: 40px !important;
  }
  .category-items {
    width: 100% !important;
  }
}
@media only screen and (max-width: 567px) {
  .category-items {
    display: flex !important;
    flex-wrap: nowrap !important;
    overflow-x: hidden;
    width: 100% !important;
  }
  .categories-section {
    width: 100%;
    max-width: none;
  }
  .categories-header {
    font-size: 30px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/presentation/main/sell-with-pamo/component/categories/categories.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,iBAAA;EACA,iBAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,6BAAA;AACF;;AAGA;EAEE;IACE,aAAA;IACA,4BAAA;IACA,yBAAA;IACA,sBAAA;EADF;AACF;AAKA;EAEE;IACE,0BAAA;EAJF;EAOA;IACE,sBAAA;EALF;AACF;AAUA;EACE;IACE,wBAAA;IACA,4BAAA;IACA,kBAAA;IACA,sBAAA;EARF;EAWA;IACE,WAAA;IACA,eAAA;EATF;EAYA;IACE,0BAAA;EAVF;AACF","sourcesContent":[".categories-section {\n  margin-top: 5%;\n  margin-bottom: 5%;\n  padding-left: 10%;\n}\n\n.categories-images-container {\n  background: #98e8fc;\n  width: 130px;\n  height: 130px;\n}\n\n.category-image {\n  width: 60px;\n  height: 100%;\n  object-fit: contain;\n}\n\n.categories-header {\n  font-size: 50px;\n}\n\n.category-items {\n  overflow-y: scroll;\n  overflow-x: hidden !important;\n}\n\n\n@media only screen and (max-width: 992px) {\n\n  .category-items{\n    display:flex;\n    flex-wrap: nowrap !important;\n    overflow: auto !important;\n    width:100% !important; \n  }\n}\n\n\n@media only screen and (max-width: 767px) {\n\n  .categories-header {\n    font-size: 40px !important;\n  }\n\n  .category-items {\n    width:100% !important; \n  }\n}\n\n\n\n@media only screen and (max-width: 567px) {\n  .category-items {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    overflow-x: hidden;\n    width:100% !important; \n  }\n\n  .categories-section {\n    width: 100%;\n    max-width: none;\n  }\n\n  .categories-header {\n    font-size: 30px !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
